import { z } from 'zod'

export const authChangePasswordSchema = z.object({
  senha: z
    .string()
    .min(1, 'Preencha uma nova senha')
    .min(6, 'Senha muito fraca!'),
  confirmarSenha: z
    .string()
    .min(1, 'Necessário a confirmação da senha'),
}).refine((data) => data.senha === data.confirmarSenha, {
  message: 'Senhas devem ser iguais',
  path: ['confirmarSenha'],
})

export type AuthChangePasswordSchema = z.infer<typeof authChangePasswordSchema>